"use client";

import { useTranslations } from "next-intl";
import { HStack, Stack, Text } from "@leabankab/component-library";
import { useCurrency } from "@/hooks";
import { ResolvedConfirmDebtItem } from "../types";

interface FetchedDebtCardProps {
	debt: ResolvedConfirmDebtItem;
	typeLabel: string;
	icon: React.ReactNode;
}

export const FetchedDebtCard = ({
	debt,
	typeLabel,
	icon,
}: FetchedDebtCardProps) => {
	const t = useTranslations("pages.ConfirmDebtPage");
	const { format } = useCurrency();

	return (
		<HStack
			render={<li />}
			gap={1.5}
			justify="between"
			align="center"
			className="rounded-xl border border-border-subtle py-1.5 ps-1.5 pe-2"
		>
			{icon}
			<Stack className="min-w-0">
				{typeLabel && (
					<Text fontWeight="semibold" color="text.base">
						{typeLabel}
					</Text>
				)}
				{debt.bank || debt.description ? (
					<Text textStyle="body-md" color="text.base">
						{debt.bank} {debt.bank && debt.description ? "- " : ""}
						{debt.description && debt.description}
					</Text>
				) : null}
			</Stack>

			<Stack className="items-end ml-auto">
				<Text fontWeight="medium" color="text.base">
					{format(debt.amount)}
				</Text>
				{debt.monthlyAmount != null && (
					<Text textStyle="body-sm" color="text.base">
						{t("monthlyAmount", { amount: format(debt.monthlyAmount) })}
					</Text>
				)}
			</Stack>
		</HStack>
	);
};
